exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".center-button {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  z-index: 1000;\n}\n.alert-secondary {\n  color: #383d41;\n  background-color: #e2e3e5;\n  border-color: #d6d8db;\n}\n.action-completed {\n  background-color: #f3f1f6;\n  padding: 8px 15px;\n  border: 1px solid #eceeef;\n}\n.action-completed p {\n  margin: 0;\n  line-height: 20px;\n  font-weight: 500;\n  letter-spacing: 0px;\n}\n.use-newlines {\n  overflow-wrap: break-word;\n}\n", ""]);

// exports
